export const environment = {
  url: {
    api: `https://apim-uat.houseofhr.com/square-app-houseofcovebo/api/v2.0`,
  },
  production: true,
  ocpApimSubscriptionKey: 'd2986cd4fcd34654bfc5ebb1b864e7cd'
};

